import { useEffect, useState } from 'react';
import InfoPanel from 'components/InfoPanel';
import Loading from 'components/Loading';
import { useLocation } from 'contexts/LocationContext';
import { Location, MapType } from 'types';
import { HeatMap, MarkerMap } from './components';
import { useMapInstance } from './useMapInstance';

const ACT_CENTER_COORDINATE = { lat: -35.2809, lng: 149.13 };
const DEFAULT_ZOOM = 12;

type MapProps = {
  locations: Location[];
};

export default function Map({ locations }: MapProps) {
  const { isLoaded } = useMapInstance();

  const [location] = useLocation();

  const [mapCenter, setMapCenter] = useState(ACT_CENTER_COORDINATE);
  const [mapZoom, setMapZoom] = useState(DEFAULT_ZOOM);
  const [mapType, setMapType] = useState(MapType.Marker);
  const [heatMapFilter, setHeatMapFilter] = useState('');

  // reset to original zoom everytime heatmap is rendered
  useEffect(() => {
    if (mapType === MapType.Heat) {
      setMapZoom(DEFAULT_ZOOM);
    }
  }, [mapType]);

  useEffect(() => {
    if (location) {
      changeMapType(MapType.Marker);
      recenterMap(location);
    }
  }, [location]);

  const recenterMap = (location: Location) => {
    setMapZoom(14);
    setMapCenter({ lat: location.latitude, lng: location.longitude });
  };

  const changeMapType = (type: MapType) => {
    setMapType(type);
  };

  return (
    <div>
      <h2>Upgrades across the ACT</h2>
      <div id="act-dashboard-google-map" className="sm:section relative">
        <InfoPanel
          changeMapType={changeMapType}
          setHeatMapFilter={setHeatMapFilter}
          locations={locations}
        />
        {!isLoaded ? (
          <Loading />
        ) : mapType === MapType.Marker ? (
          <MarkerMap
            mapCenter={mapCenter}
            mapZoom={mapZoom}
            locations={locations}
          />
        ) : (
          <HeatMap
            mapCenter={mapCenter}
            mapZoom={mapZoom}
            locations={locations}
            heatMapFilter={heatMapFilter}
          />
        )}
      </div>
    </div>
  );
}
